<template>
  <div class="container-fluid">
    <div class="row fme-new-edit__title fme-montserrat-font">
      <div class="col-md-9">
        <h3>
          {{
            $t(`supervision.crud.page.${crudCurrentPageTitle}`) | textUpperCase
          }}
        </h3>
      </div>

      <div class="col-md-3 fme-new-edit__buttons text-right">
        <BaseButtonEvent
          :btText="$t('supervision.crud.button.goBack')"
          btClickType="goBack"
          btId="newEditeGoBack"
          btClickValue=""
          btUrlGoBack="CrudUserListPage"
          btCss="btn fme-btn fme-btn-secondary"
        />

        <span v-if="isUserAllowToEdit">
          <BaseButtonEvent
            v-if="clientDeactivatedCrud === null"
            :btText="$t('supervision.crud.button.disable')"
            btClickType="sendDeleteWarning"
            :btClickValue="id"
            btId="clientIdCrud"
            :btUrlGo="urlDeactivate"
            btCss="btn fme-btn fme-btn-primary"
            btUrlGoBack="CrudClientListPage"
            :nameAlert="clientName"
            prefixAlert="o"
            typeAlert="cliente"
            dependentAlert="locais"
            :listAlert="clientLocations"
          />
          <BaseButtonEvent
            v-else
            :btText="$t('supervision.crud.button.enable')"
            btClickType="sendActivateCrud"
            :btClickValue="id"
            btId="clientIdCrud"
            :btUrlGo="urlActivate"
            btCss="btn fme-btn fme-btn-primary fme-btn-back"
            btUrlGoBack="CrudClientListPage"
          />
        </span>
      </div>
    </div>

    <div class="row">
      <div class="col-md-12">
        <BaseInput
          :inputCurrentValue="clientName"
          :inputTitle="$t('supervision.crud.form.client.name.title')"
          :inputPlaceholder="
            $t('supervision.crud.form.client.name.placeholder')
          "
          inputType="text"
          inputCss=""
          inputId="input-client-name"
          @returned-input-value="clientInput('name', $event)"
          :inputErrorText="clientError.name ? $t(clientError.name) : $t(clientError.role)"
          :inputDisabled="!isUserAllowToEdit"
        />
      </div>
    </div>

    <div v-if="isUserAllowToEdit" class="row fme-new-edit__row--last text-right">
      <div class="col-md-12">
        <BaseButtonEvent
          :btText="$t('supervision.crud.button.save')"
          :btClickType="saveValues.type"
          :btClickValue="newClient"
          :btId="saveValues.id"
          :btUrlGo="saveValues.urlGo"
          :btUrlGoBack="saveValues.urlBack"
          btCss="btn fme-btn fme-btn-primary"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { fetchFeatureToggles } from '../../../../services/featureToggler';
import { checkIfUserIsAllowToEdit } from '../../../../utils/checkIfUserIsAllowToEdit';
import { getV3Token } from '../../../../utils/getV3Token'; 
import { getUserRole } from '../../../../utils/getUserRole'; 

import axios from "axios";

const BaseInput = () => import("@/components/fragment/input/BaseInput");
const BaseButtonEvent = () =>
  import("@/components/fragment/button/BaseButtonEvent");

export default {
  name: "EditPage",
  async created() {
    this.clearStore();
    this.hasClient();
    this.changeCrudCurrentPageTitle("client");
    await this.getFeatures();
    this.checkUserPermissions();
  },
  update() {
    this.hasClient();
  },
  beforeDestroy() {
    this.clearStore();
    this.changeErrors([]);
  },
  data() {
    return {
      saveValues: {
        type: "sendPutCrud",
        id: "btUpdateClient",
        urlGo: `${process.env.VUE_APP_CRUD_URL_CLIENTS}/${this.uuid}`,
        urlBack: "CrudClientListPage",
      },
      clientError: {
        name: "",
        role: "",
      },
      isUserAllowToEdit: false
    };
  },
  props: {
    id: {
      type: String,
    },
    uuid: {
      type: String,
    },
  },
  components: {
    BaseInput,
    BaseButtonEvent,
  },
  clientList: ["pera", "maçãs", "mamãos", "melões"],
  computed: {
    ...mapGetters(["axiosHeaders1", "headersCrud"]),
    ...mapGetters("ModuleErrors", ["errorsList"]),
    ...mapGetters("ModuleSupervision", [
      "clientCrud",
      "clientIdCrud",
      "clientNameCrud",
      "clientLocationsCrud",
      "clientDeactivatedCrud",
      "crudCurrentPageTitle",
    ]),
    clientName() {
      return this.clientNameCrud;
    },
    clientLocations() {
      if(this.clientLocationsCrud){
        return this.clientLocationsCrud.map((l) => l.name);
      }
    },
    newClient() {
      let client = {
        name: this.clientNameCrud,
      };

      return client;
    },
    urlActivate() {
      return `${process.env.VUE_APP_CRUD_URL_CLIENTS}/${this.uuid}/activate`;
    },
    urlDeactivate() {
      return `${process.env.VUE_APP_CRUD_URL_CLIENTS}/${this.uuid}/deactivate`;
    },
  },
  methods: {
    ...mapActions("ModuleErrors", ["changeErrors"]),
    ...mapActions("ModuleSupervision", [
      "changeClientIdCrud",
      "changeClientNameCrud",
      "changeClientDeactivatedCrud",
      "changeCrudCurrentPageTitle",
      "changeClientLocationsCrud",
    ]),
    hasClient() {
      if (this.id !== "" && !isNaN(this.id)) {
        let url = `${process.env.VUE_APP_CRUD_URL_CLIENTS}/${this.uuid}`;

        axios
          .get(url, {
            headers: this.headersCrud,
          })
          .then((response) => {
            return response.data;
          })
          .then((client) => {
            this.setClient(client);
          })
          .catch((e) => {
            if (e.response.status && e.response.status === 401) {
              this.logoutUser();
            } else {
              console.log(e);
            }
          });
      } else {
        this.$router.push({ name: "CrudClientListPage" });
      }
    },
    setClient(client) {
      this.changeClientIdCrud(client.id);
      this.changeClientNameCrud(client.name);
      this.changeClientLocationsCrud(client.locations);
      this.changeClientDeactivatedCrud(client.deactivatedAt);
    },
    clientInput(refValue, eventValue) {
      if (refValue === "name") {
        this.changeClientNameCrud(eventValue);
      }
    },
    clearStore() {
      this.changeClientIdCrud("");
      this.changeClientNameCrud("");
      this.changeClientDeactivatedCrud("");
      this.changeClientLocationsCrud([]);
    },
    async getFeatures() {
      try {
        const response = await fetchFeatureToggles(getV3Token());
        this.features = response;
      } catch (error) {
        console.error(error);
      }
    },
    checkUserPermissions() {
      if (this.features) {
        this.isUserAllowToEdit = checkIfUserIsAllowToEdit(this.features, getUserRole());
      } else {
        console.error("Features are not available yet.");
      }
    }
  },
  filters: {},
  watch: {
    errorsList() {
      this.clientError.name = "";
      this.clientError.role = "";
      
      this.errorsList.map((error) => {
        if(error.error === "User does not have permission to perform this action") {
          this.clientError.role = `errors.role.unauthorized`;
        }

        if (error.property.indexOf("name") !== -1) {
          if (this.hasProperty(error.constraints, "isNotEmpty")) {
            this.clientError.name = `errors.name.required`;
          } else if (
            this.hasProperty(error.constraints, "IsClientConstraint")
          ) {
            this.clientError.name = `errors.name.uniqueness`;
          }
        }
      });
    },
  },
};
</script>

<style lang="scss">
</style>
